export const GET_ALLOCATOR_NETWORKS = "ALLOCATOR@GET_ALLOCATOR_NETWORKS";
export const GET_ALLOCATOR_NETWORKS_INIT = "ALLOCATOR@GET_ALLOCATOR_NETWORKS_INIT";
export const GET_ALLOCATOR_NETWORKS_SUCCESS = "ALLOCATOR@GET_ALLOCATOR_NETWORKS_SUCCESS";
export const GET_ALLOCATOR_NETWORKS_FAILED = "ALLOCATOR@GET_ALLOCATOR_NETWORKS_FAILED";

export const GET_ALLOCATOR_NETWORK_STATS = "ALLOCATOR@GET_ALLOCATOR_NETWORK_STATS";
export const GET_ALLOCATOR_NETWORK_STATS_INIT = "ALLOCATOR@GET_ALLOCATOR_NETWORK_STATS_INIT";
export const GET_ALLOCATOR_NETWORK_STATS_SUCCESS = "ALLOCATOR@GET_ALLOCATOR_NETWORK_STATS_SUCCESS";
export const GET_ALLOCATOR_NETWORK_STATS_FAILED = "ALLOCATOR@GET_ALLOCATOR_NETWORK_STATS_FAILED";

export const CREATE_ALLOCATOR_NETWORKS = "ALLOCATOR@CREATE_ALLOCATOR_NETWORKS";
export const CREATE_ALLOCATOR_NETWORKS_INIT = "ALLOCATOR@CREATE_ALLOCATOR_NETWORKS_INIT";
export const CREATE_ALLOCATOR_NETWORKS_SUCCESS = "ALLOCATOR@CREATE_ALLOCATOR_NETWORKS_SUCCESS";
export const CREATE_ALLOCATOR_NETWORKS_FAILED = "ALLOCATOR@CREATE_ALLOCATOR_NETWORKS_FAILED";

export const UPDATE_ALLOCATOR_NETWORKS = "ALLOCATOR@UPDATE_ALLOCATOR_NETWORKS";
export const UPDATE_ALLOCATOR_NETWORKS_INIT = "ALLOCATOR@UPDATE_ALLOCATOR_NETWORKS_INIT";
export const UPDATE_ALLOCATOR_NETWORKS_SUCCESS = "ALLOCATOR@UPDATE_ALLOCATOR_NETWORKS_SUCCESS";
export const UPDATE_ALLOCATOR_NETWORKS_FAILED = "ALLOCATOR@UPDATE_ALLOCATOR_NETWORKS_FAILED";

export const GET_INVESTOR_TYPE = "ALLOCATOR@GET_INVESTOR_TYPE";
export const GET_INVESTOR_TYPE_INIT = "ALLOCATOR@GET_INVESTOR_TYPE_INIT";
export const GET_INVESTOR_TYPE_SUCCESS = "ALLOCATOR@GET_INVESTOR_TYPE_SUCCESS";
export const GET_INVESTOR_TYPE_FAILED = "ALLOCATOR@GET_INVESTOR_TYPE_FAILED";

export const DELETE_ALLOCATOR_NETWORKS = "ALLOCATOR@DELETE_ALLOCATOR_NETWORKS";
export const DELETE_ALLOCATOR_NETWORKS_INIT = "ALLOCATOR@DELETE_ALLOCATOR_NETWORKS_INIT";
export const DELETE_ALLOCATOR_NETWORKS_SUCCESS = "ALLOCATOR@DELETE_ALLOCATOR_NETWORKS_SUCCESS";
export const DELETE_ALLOCATOR_NETWORKS_FAILED = "ALLOCATOR@DELETE_ALLOCATOR_NETWORKS_FAILED";

export const GET_ALLOCATOR_USERS = "ALLOCATOR@GET_ALLOCATOR_USERS";
export const GET_ALLOCATOR_USERS_INIT = "ALLOCATOR@GET_ALLOCATOR_USERS_INIT";
export const GET_ALLOCATOR_USERS_SUCCESS = "ALLOCATOR@GET_ALLOCATOR_USERS_SUCCESS";
export const GET_ALLOCATOR_USERS_FAILED = "ALLOCATOR@GET_ALLOCATOR_USERS_FAILED";